import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Instagram } from 'lucide-react';
import { contactInfo } from '../mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Collections', path: '/#collections' },
    { name: 'About', path: '/#about' },
    { name: 'Gallery', path: '/#gallery' },
    { name: 'Contact', path: '/#contact' }
  ];

  const scrollToSection = (hash) => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const handleNavClick = (e, path) => {
    if (path.includes('#')) {
      e.preventDefault();
      const hash = path.split('#')[1];
      if (location.pathname !== '/') {
        window.location.href = '/#' + hash;
      } else {
        scrollToSection('#' + hash);
      }
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex flex-col">
            <h1 className="text-2xl md:text-3xl font-bold tracking-tight">
              <span className="text-[#dc143c]">BHARGAVA'S</span>{' '}
              <span className="text-[#1a1a2e]">SHOES</span>
            </h1>
            <p className="text-xs text-[#666] tracking-wider">SINCE 1911 • FLEX WALE</p>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.path}
                onClick={(e) => handleNavClick(e, link.path)}
                className="text-sm font-medium text-[#1a1a2e] hover:text-[#dc143c] transition-colors duration-300 tracking-wide"
              >
                {link.name}
              </a>
            ))}
            <a
              href={`tel:${contactInfo.phone}`}
              className="flex items-center gap-2 bg-[#dc143c] text-white px-5 py-2.5 rounded-sm hover:bg-[#b01030] transition-all duration-300"
            >
              <Phone size={16} />
              <span className="text-sm font-medium">Call Now</span>
            </a>
          </nav>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-[#dc143c]"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <nav className="md:hidden mt-6 pb-6 flex flex-col gap-4 border-t border-[#f7f5f2] pt-6">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.path}
                onClick={(e) => handleNavClick(e, link.path)}
                className="text-base font-medium text-[#1a1a2e] hover:text-[#dc143c] transition-colors duration-300"
              >
                {link.name}
              </a>
            ))}
            <a
              href={`tel:${contactInfo.phone}`}
              className="flex items-center justify-center gap-2 bg-[#dc143c] text-white px-5 py-3 rounded-sm hover:bg-[#b01030] transition-all duration-300"
            >
              <Phone size={18} />
              <span className="text-base font-medium">Call Now</span>
            </a>
            <a
              href={contactInfo.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 border-2 border-[#dc143c] text-[#dc143c] px-5 py-3 rounded-sm hover:bg-[#dc143c] hover:text-white transition-all duration-300"
            >
              <Instagram size={18} />
              <span className="text-base font-medium">Follow Us</span>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
